import { render, staticRenderFns } from "./PointsCouldTable.vue?vue&type=template&id=0710f146&"
import script from "./PointsCouldTable.vue?vue&type=script&lang=js&"
export * from "./PointsCouldTable.vue?vue&type=script&lang=js&"
import style0 from "./PointsCouldTable.vue?vue&type=style&index=0&id=0710f146&prod&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports